(function () {
  if (window.__collapseInit) return;
  window.__collapseInit = true;

  function bind(wrap) {
    if (wrap.__collapseBound) return;
    wrap.__collapseBound = true;

    var trigger = wrap.querySelector('[data-collapse-trigger]');
    var content = wrap.querySelector('[data-collapse-content]');
    if (!trigger || !content) return;

    trigger.addEventListener('click', function () {
      var isOpen = wrap.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      content.style.maxHeight = isOpen ? content.scrollHeight + 'px' : null;
    });
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-collapse]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
